import "../styles/Scan.scss";

import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { checkWearableId, setWearableId, patchWearableId, setWearableIdCaserta, patchWearableIdCaserta } from "../utils/api";

import Loader from "./Loader";
import QrScanner from "qr-scanner";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

function Scan(props) {
  const { t } = props;
  const navigate = useNavigate();

  const videoEl = useRef(null);
  
  const [showScanCheckModal, setShowScanCheckModal] = useState(false);
  const handleCloseScanCheckModal = () => setShowScanCheckModal(false);
  const handleSaveScanCheckModal = async () => {
    props.setIsLoading(true);
    let setWearableIdSuccess;
    try {
      setWearableIdSuccess = await setWearableId(scanResponse?.uid);
    } catch (error) {
        // console.log('______ ******* setWearableId error *******', error, setWearableIdSuccess);
        try {
          setWearableIdSuccess = await patchWearableId(scanResponse?.uid);
        } catch (error) {
          // console.log('______ ******* patchWearableId error *******', error, setWearableIdSuccess);
          props.setShowScanErrorModal(true);
        }
    } finally {
      if (setWearableIdSuccess?.statusCode === 201) {
        // console.log('______ !!!!!!! finally handleSaveScanCheckModal !!!!!!!', setWearableIdSuccess);
        await props.getWearables(props.setScanPasses);
      }
      props.setIsLoading(false);
      setShowScanCheckModal(false);
      props.scanner?.current?.stop();
      navigate("/welcome");
    }
  };

  const [scanResponse, setScanResponse] = useState(false);

  const onScanCheck = async (result) => {
    const wearableId = result.data;
    // console.log('______ onScanCheck id', wearableId);
    let scanRes;
    if (wearableId) {
      try {
        scanRes = await checkWearableId(wearableId);
        setScanResponse(scanRes);
      } catch (error) {
        // console.log('______ ******* checkWearableId error *******', error);
        props.setShowScanErrorModal(true);
        props.scanner?.current?.stop();
        navigate("/welcome");
      } finally {
        // console.log('______ !!!!!!! finally onScanCheck !!!!!!!', wearableId === scanResponse?.uid);
        setShowScanCheckModal(true);
        props.scanner?.current?.stop();
      }
    }
  };
  const onScanFail = (error) => {
    // console.log('_____ scanner none', error);
  };

  useEffect(() => {
    if (videoEl?.current) {
      props.scanner.current = new QrScanner(videoEl?.current, onScanCheck, {
        onDecodeError: onScanFail,
        // preferredCamera: "user",
        highlightScanRegion: true,
        highlightCodeOutline: true,
        maxScansPerSecond: 2,
      });
      if (!showScanCheckModal) props.scanner?.current?.start()
        .then(
          // console.log('_____ scanner start')
        ).catch((error) => {
          // console.log('_____ scanner error', error);
        });
    }
  });

  // useEffect(() => {
  //   if (props.scanner?.current) props.scanner?.current?.stop()
  //   if (props.scanPasses) navigate("/welcome");
  // }, [props.scanPasses]);

  return (
    <>
      <div className="qr-reader">
        {/* <Loader />  */}
        <video preload="none" ref={videoEl}></video>
      </div>
      <Container fluid>
        <Row>
          <Col>
            <div className="scan-me">
              {t("messages.msg.scan")}
            </div>
          </Col>
        </Row>
      </Container>

      <Modal show={showScanCheckModal} onHide={handleCloseScanCheckModal} centered>
        <Modal.Body>
          {scanResponse?.uid && <>
            <p className="page-subtitle">{t("scan.title.wearable.checked")}</p>
            <h1 className="page-title">{scanResponse?.uid}</h1>
            <div className="event-table">
              <div className="event-table-cell"><b>{scanResponse?.eventName}</b></div>
              <div className="event-table-cell">{t("welcome.event.wearable.paired.area")} <b>{scanResponse?.areaName}</b></div>
              <div className="event-table-cell">{t("welcome.event.wearable.paired.valid")} <b>{scanResponse?.valid === true ? t("scan.event.valid") : (scanResponse?.valid === false ? t("scan.event.not.valid") : '')}</b></div>
            </div>
          </>}
          {props.scanPasses?.filter((event) => event?.eventId === scanResponse?.eventId).length > 0 && <>
            <h2 className="page-title">{t("scan.title.wearable.not.to.pair")}</h2>
            <p className="page-subtitle">{t("scan.title.wearable.other.to.pair")} {scanResponse?.eventName}</p>
          </>}
        </Modal.Body>
        <Modal.Footer>
          {props.scanPasses?.filter((event) => event?.eventId === scanResponse?.eventId).length > 0 ? '' : <Button variant="primary" onClick={() => { handleSaveScanCheckModal();}} disabled={scanResponse?.valid === false}>
            {t("scan.cta.wearable.to.pair")}
          </Button>}
          <Button variant="secondary" onClick={() => { handleCloseScanCheckModal();}}>
            {props.scanPasses?.filter((event) => event?.eventId === scanResponse?.eventId).length > 0 || scanResponse?.valid === false ? t("scan.cta.wearable.other.to.pair") : t("scan.cta.wearable.undo") }
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Scan;
